import type { ActionType } from 'components/molecules/RichTextInput/types';

export const FUNCTION_PREFIX = 'fn:';
export const FLOW_TRANSITION_PREFIX = 'ft:';
export const HANDOFF_PREFIX = 'ho:';
export const TWILIO_SMS_PREFIX = 'twilio_sms:';
export const VARIANT_ATTRIBUTE_PREFIX = 'attr:';
export const VARIABLE_PREFIX = 'vrbl:';

export const ALL_ACTION_PREFIXES = [
  FUNCTION_PREFIX,
  FLOW_TRANSITION_PREFIX,
  HANDOFF_PREFIX,
  TWILIO_SMS_PREFIX,
  VARIABLE_PREFIX,
];

export const prefixMap: { [key: string]: ActionType } = {
  [FUNCTION_PREFIX]: 'function',
  [HANDOFF_PREFIX]: 'handoff',
  [TWILIO_SMS_PREFIX]: 'twilio_sms',
  [FLOW_TRANSITION_PREFIX]: 'flow_transition',
  [VARIANT_ATTRIBUTE_PREFIX]: 'variant_attribute',
  [VARIABLE_PREFIX]: 'variable',
};

export const codeInputPlaceholder =
  '  # Add your function definition here.\n  # You can optionally return a string that will be fed back to the LLM.\n  pass';
